import { render, staticRenderFns } from "./check-bonus.vue?vue&type=template&id=8bb5ad7a&scoped=true"
import script from "./check-bonus.vue?vue&type=script&lang=js"
export * from "./check-bonus.vue?vue&type=script&lang=js"
import style0 from "./check-bonus.vue?vue&type=style&index=0&id=8bb5ad7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb5ad7a",
  null
  
)

export default component.exports